import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersonalInformationEditCardUtil {

  constructor() {
  }

  private readonly FORM_CONTROL_NAMES_MAP: Record<string, string> = {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    password: 'Password',
    phone: 'Phone'
  };

  public getFormattedLabelForFormControl(formControlName: string): string {
    return this.FORM_CONTROL_NAMES_MAP[formControlName];
  }

}
